import { RestrictionType } from '@/shared/enums';

export default {
  data() {
    return {
      subscriber: this.$services.resolve('subscriber'),
    };
  },
  methods: {
    getProductAvailability(product) {
      return !product.restrictionType
        || (product.restrictionType === RestrictionType.ANONYMOUS && !this.subscriber.isLogged)
        || (product.restrictionType === RestrictionType.SUBSCRIBER && this.subscriber.isLogged);
    },
  },
};
